import * as React from "react";

import { FullPageStatusComponent } from "./FullPageStatusComponent";
import { FullPageErrorComponent } from "./FullPageErrorComponent";

import { IPageStatus, PageStatusFlags } from "../ComponentDataModels/IPageStatus";
import { clientAppSettings } from "../../Models/ClientAppSettings";
import { CultureUtility } from '../../Resources/CultureUtility';
import { Resources } from "../../Resources/Intercom.Resources.DevPortal";

export interface IbizaWebChatPageProps extends React.Props<IbizaWebChatPage> {
    pageStatus: IPageStatus;
    pageMessage: string;
    botId: string;
    location: string;
    webChatToken?: string;
    onStartNewConversation: () => void;
}

export class IbizaWebChatPage extends React.Component<IbizaWebChatPageProps, {}> {
    render(): JSX.Element {
        const { location, pageMessage, webChatToken, botId } = this.props;
        const hasPageError = !!pageMessage;
        const fullPageMessage = this._getFullPageMessage();

        if (!fullPageMessage && !webChatToken) {
            throw new Error("No WebChat token.");
        }

        let webChatUrl = clientAppSettings.webChatUrl;

        if(location && location !== 'global') {
            const items = clientAppSettings.webChatUrl.split('//');
            let hostName = clientAppSettings.webChatUrl;
            let protocol = '';
            if(items.length === 2) {
                protocol = `${items[0]}//`;
                hostName = items[1];
            }
            if(hostName.indexOf(location) === -1) {
                webChatUrl = `${protocol}${location}.${hostName}`
            }
        } 

        let frameSrc = `${webChatUrl}embed/${botId}?t=${webChatToken}`;
        if (CultureUtility.rawLocale)
            frameSrc += `&l=${CultureUtility.rawLocale}`;

        return (
            <div className="ibiza-webchat-page">
                <div aria-live="polite">
                    <span className="offscreen">{fullPageMessage || Resources.loadingBot}</span>
                </div>
                {
                    fullPageMessage ? (
                        hasPageError ?
                            <FullPageErrorComponent message={ fullPageMessage } />
                        :
                            <FullPageStatusComponent message={ fullPageMessage } />
                    ) : [
                        // React.Fragment is not available in this version of React (15.4.2).
                        // So we are using array for readability for now.
                        <div className="test-header" key="1">
                            <div className="test-header-text">{Resources.test}</div>
                            <button className="test-header-reload-button"
                                    onClick={() => this.props.onStartNewConversation()}>
                                <span className="m-icon-Refresh test-header-reload-button-icon"></span>
                                    <span className="test-header-reload-button-text">
                                        {Resources.startOver}
                                    </span>
                            </button>
                        </div>,
                        <iframe
                            className="chat-frame"
                            title="Web chat"
                            key="2"
                            // The current version of React (15.4.2) does not support "allow" attribute in JSX
                            // We need to use "ref callback" to add it in manually
                            ref={ element => element && element.setAttribute('allow', 'microphone *') }
                            src={ frameSrc }
                        />
                    ]
                }
            </div>
        );
    }

    private _getFullPageMessage() {
        if (this.props.pageMessage) {
            // If we have a message to display - show that.
            return this.props.pageMessage;
        }
        else if (this.props.pageStatus.hasPageStatusFlag(PageStatusFlags.WaitingForWebChatToken)) {
            return Resources.authorizingWebChat;
        }
        else if (this.props.pageStatus.hasPageStatusFlag(PageStatusFlags.LoggingIn)) {
            return Resources.loggingIn;
        }
        else if (this.props.pageStatus.hasPageStatusFlag(PageStatusFlags.WaitingForBotReady)) {
            return Resources.botIsNotReady;
        }
        else if (!this.props.pageStatus.isReady()) {
            // If the page is not ready to display show a status page.
            return Resources.loading;
        }
    }

}



// WEBPACK FOOTER //
// ./Client/v4/Views/IbizaWebChatPage.tsx